module.exports = __webpack_public_path__ + "static/media/brand-logo.cbfa3636.svg";